<template>
  <div class="view width-840">
    <div class="heading-1">
      Today's Most Active Students
    </div>

    <MostActiveTable :date="date" type="user-engagement-daily-analytics" />
  </div>
</template>

<script>
// mixins
import time from '@/mixins/time.js'

// components
import MostActiveTable from '@/components/students/MostActiveTable.vue'

export default {
  mixins: [time],

  computed: {
    /*
     *
     */
    date () {
      return this.dateKey.startOf('day').toDate()
    }
  },

  components: {
    MostActiveTable
  }
}
</script>

<style>

</style>